import ClickStreamEvent from '@tekion/tekion-base/events/clickStream/builders/ClickStreamEvent';
import CLICKSTREAM_EVENT_TYPES from '@tekion/tekion-base/events/clickStream/constants/clickstream.eventTypes';
import { fireClickstreamEvent } from '@tekion/tekion-base/events/clickStream/helpers/clickStream.eventEmitter';
export var fireSaveNewFilterGroupClickStreamEvent = function fireSaveNewFilterGroupClickStreamEvent(_ref) {
  var module = _ref.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.SAVE_NEW_FILTER_GROUP).setEventProperties({
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};
export var fireApplyFilterGroupClickStreamEvent = function fireApplyFilterGroupClickStreamEvent(_ref2) {
  var module = _ref2.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.APPLY_FILTER_GROUP).setEventProperties({
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};
export var fireUpdateFilterGroupClickStreamEvent = function fireUpdateFilterGroupClickStreamEvent(_ref3) {
  var module = _ref3.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.UPDATE_FILTER_GROUP).setEventProperties({
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};
export var fireDeleteFilterGroupClickStreamEvent = function fireDeleteFilterGroupClickStreamEvent(_ref4) {
  var module = _ref4.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.DELETE_FILTER_GROUP).setEventProperties({
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};